import type { School } from "@/api";

export function getSchoolDomains(school: School): string[] {
  return school.domains.map((row) => row.domain);
}

export function getEmailDomain(email: string): string {
  return email.trim().toLowerCase().split("@")[1] ?? "";
}

export function isSchoolAddress(school: School, email: string): boolean {
  const domains = getSchoolDomains(school);
  if (domains.length === 0) return true;

  // Mirrors School.affiliated_with on the server: a subdomain of a school
  // domain counts too (g.harvard.edu matches harvard.edu).
  const domain = email.trim().toLowerCase().split("@")[1];
  if (!domain) return false;

  return domains.some((schoolDomain) => {
    const normalized = schoolDomain.toLowerCase();
    return domain === normalized || domain.endsWith(`.${normalized}`);
  });
}

export function hasEduDomain(school: School): boolean {
  return getSchoolDomains(school).some((domain) => domain.toLowerCase().endsWith(".edu"));
}
